// Home Page Query
export const homePageQuery = `*[_type == "homePage"][0]{
    title,
    introText
  }`

// Tandara Details Query (for global contact information)
export const tandaraDetailsQuery = `*[_type == "tandaraDetails"][0]{
    title,
    phoneNumber,
    faxNumber,
    emailAddress,
    streetAddress
  }`

// Contact Page Query
export const contactPageQuery = `*[_type == "contactPage"][0]{
    title,
    subtitle,
    contactTitle,
    addressTitle,
    phoneTitle,
    faxTitle,
    emailTitle
  }`

// Vision & Mission Page Query
export const visionMissionPageQuery = `*[_type == "visionMissionPage"][0]{
    title,
    subtitle,
    visionHeader,
    visionText,
    missionHeader,
    missionText,
    commitmentHeader,
    commitmentText
  }`

// Residential Page Query
export const residentialPageQuery = `*[_type == "residentialPage"][0]{
    title,
    subtitle,
    eligibilityHeader,
    eligibilityText,
    costHeader,
    costTexta
  }`

// Respite Page Query
export const respitePageQuery = `*[_type == "respitePage"][0]{
    title,
    subtitle,
    introText,
    costHeader,
    costText,
    applicationHeader,
    applicationText
  }`

// Independent Living Page Query
export const independentLivingPageQuery = `*[_type == "independentLivingPage"][0]{
    title,
    subtitle,
    iluHeader,
    iluText,
    applicationHeader,
    applicationText
  }`

// Location Page Query
export const locationPageQuery = `*[_type == "locationPage"][0]{
    title,
    subtitle,
    introText,
    addressHeader,
    aboutSheffieldHeader,
    aboutSheffieldText
  }`

// Fees Page Query
export const feesPageQuery = `*[_type == "feesPage"][0]{
    title,
    subtitle,
    introText,
    chargesList,
    tableHeader1,
    tableHeader2,
    tableHeader3,
    tableRows[]{
      description,
      dap,
      rad
    },
    combinationText,
    importantNote,
    additionalNotesList,
    conclusionText
  }`


// Links Page Query
export const linksPageQuery = `*[_type == "linksPage"][0]{
    title,
    subtitle,
    introText,
    links[]{
      linkTitle,
      linkDescription,
      linkUrl,
      displayUrl
    }
  }`

// Events Page Query
export const eventsPageQuery = `*[_type == "eventsPage"][0]{
    title,
    subtitle,
    introText,
    calendarText,
    eventCalendars[]{
      month,
      year,
      calendarTitle,
      "documentUrl": document.asset->url
    }
  }`

// News Page Query
export const newsPageQuery = `*[_type == "newsPage"][0]{
    title,
    subtitle,
    introText,
    newsItems[]{
      newsTitle,
      "documentUrl": document.asset->url
    },
    financialReportsHeader,
    financialReportsText,
    financialReports[]{
      reportTitle,
      "documentUrl": document.asset->url
    }
  }`

// Privacy Page Query
export const privacyPageQuery = `*[_type == "privacyPage"][0]{
    title,
    subtitle,
    introText,
    contentText,
    "policyDocumentUrl": policyDocument.asset->url,
    policyDocumentText
  }`

// Services Page Query
export const servicesPageQuery = `*[_type == "servicesPage"][0]{
    title,
    subtitle,
    introText
  }`

// Policies Page Query
export const policiesPageQuery = `*[_type == "policiesPage"][0]{
  title,
  subtitle,
  introText,
  policies[]{
    _key,
    policyTitle,
    "documentUrl": document.asset->url
  }
}`;